import { z } from 'zod';

export const billingContactSchema = z.object({
    email: z.string(),
    lastName: z.string(),
    firstName: z.string(),
});

export type BillingContact = z.infer<typeof billingContactSchema>;



